import { cn } from "@/lib/utils";
import { t } from "@shared/i18n";

/** Logo officiel GBC Coach IA (public/brand). `full` : logo complet ; sinon pastille + logotype. */
export function Logo({ className, withText = true, full = false }: { className?: string; withText?: boolean; full?: boolean }) {
  if (full) return <img src="/brand/logo.png" alt={t("GBC Coach IA")} className={cn("h-auto w-40", className)} />;
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <img src="/brand/mark.png" alt="" className="size-9 rounded-[11px] bg-white shadow-[0_0_0_1px_var(--glass-edge),0_4px_12px_-4px_rgb(242_154_31/0.45)]" />
      {withText && (
        <span className="text-[16px] font-bold tracking-tight">
          GBC <span className="text-slate">{t("Coach")}</span> <span className="text-primary">IA</span>
        </span>
      )}
    </span>
  );
}
